import { useEffect, useRef, useState } from "react"
import { register, remove } from "../funcStore";

export function NameInput(){
  const STATE_BEFORE_INIT = "beforeInit";
  const STATE_EMPTY = "empty";
  // const STATE_ENTERING = "entering";
  const STATE_ENTERED = "entered";

  const [state,setState] = useState(STATE_BEFORE_INIT)

  const [nameInput, setnameInput] = useState("");
  const nameRef = useRef(nameInput)
  nameRef.current = nameInput

  const handleFilterName = () => (e) => {
    setnameInput(e.target.value);
    setState(e.target.value.length > 0 ?STATE_ENTERED:STATE_EMPTY)
  };

  const clearName = ()=>{
    setnameInput("");
    setState(STATE_EMPTY)
  }

  function init(){
    register("NameInputClearName",clearName)
    register("NameInputGatValue",()=>nameRef.current)
    setState(STATE_EMPTY)
  }

  useEffect(()=>{
    if(state == STATE_BEFORE_INIT){
      init()
    }
  },[state])

  useEffect(()=>{
    remove("NameInputGetValue")
  },[])
  return(
    <div style={styles.filterField}>
      <label style={styles.filterLabel} htmlFor="filter-name">
        VTuber名(部分一致)
      </label>
      <input
        id="filter-name"
        type="text"
        style={styles.filterInput}
        value={nameInput}
        onChange={handleFilterName()}
      />
    </div>
  )
}

const styles = {
  filterField: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    fontSize: "0.85rem",
  },
  filterLabel: {
    color: "#555",
  },
  filterInput: {
    padding: "6px 8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  }
};